module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree-breadcrumb",
    attrs: {
      "role": "breadcrumb"
    }
  }, [_c('div', {
    staticClass: "tree-breadcrumb-track"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1b2a1be4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/source/breadcrumb.vue
// module id = 312
// module chunks = 0